export const userTypes = {
    user: 'User',
    admin: 'Admin',
    kam: 'KAM',
    fse: 'FSE'
}